module.exports = __webpack_public_path__ + "static/img/sanwei-img.eb4d0637.png";